import React from 'react';

const footer=()=>
(
	<div>
		<span id="footer_text">
			This app uses <a className="link_api" href="https://github.com/hitbtc-com/hitbtc-api" 
			target="_blank" rel="noopener noreferrer">api</a>.  	
		</span>
		<span id="second_footer_text">
			Page List crypto has horizontal scroll 
			for mobile devices.
		</span>
	</div>	
)

export default footer;